<template>
<v-img :width="size" :height="size" :class="classFan" :style="styleFan" :src="srcFan" contain></v-img>
</template>

<script>
export default {
  name: 'Fan',
  props: {
    size: {
      type: [Number, String],
      default: 120,
    },
    power: {
      type: Boolean,
      default: false
    },
    speed: {
      type: Number,
      default: 0
    },
    direction: {
      type: Number,
      default: 0
    },
    animation: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    styleFan() {
      return this.power && this.animation ? {
        'animation-duration': `${this.speed}s`
      } : {};
    },
    classFan() {
      return this.power && this.animation ? {
        'rotating_forward': !this.direction,
        'rotating_backward': !!this.direction
      } : {}
    },
    srcFan() {
      if (this.power) {
        if (this.direction===0)
          return require('@/assets/icon/fan/fan_forward.svg');
        else
          return require('@/assets/icon/fan/fan_backward.svg');
      } else {
        return require('@/assets/icon/fan/fan_stop.svg');
      }

    }
  }
}
</script>

<style scoped>
@keyframes rotating_forward {
  from {
    transform: rotate(0deg);
    -o-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -webkit-transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
    -o-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -webkit-transform: rotate(360deg);
  }
}

@-webkit-keyframes rotating_forward {
  from {
    transform: rotate(0deg);
    -webkit-transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
    -webkit-transform: rotate(360deg);
  }
}

@keyframes rotating_backward {
  to {
    transform: rotate(0deg);
    -o-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -webkit-transform: rotate(0deg);
  }

  from {
    transform: rotate(360deg);
    -o-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -webkit-transform: rotate(360deg);
  }
}

@-webkit-keyframes rotating_backward {
  to {
    transform: rotate(0deg);
    -webkit-transform: rotate(0deg);
  }

  from {
    transform: rotate(360deg);
    -webkit-transform: rotate(360deg);
  }
}

.rotating_forward {
  -webkit-animation: rotating_forward 1s linear infinite;
  -moz-animation: rotating_forward 1s linear infinite;
  -ms-animation: rotating_forward 1s linear infinite;
  -o-animation: rotating_forward 1s linear infinite;
  animation: rotating_forward 1s linear infinite;
}

.rotating_backward {
  -webkit-animation: rotating_backward 1s linear infinite;
  -moz-animation: rotating_backward 1s linear infinite;
  -ms-animation: rotating_backward 1s linear infinite;
  -o-animation: rotating_backward 1s linear infinite;
  animation: rotating_backward 1s linear infinite;
}
</style>
